import { render } from "./PlayerDocumentsTab.vue?vue&type=template&id=1f1104d2"
import script from "./PlayerDocumentsTab.vue?vue&type=script&lang=js"
export * from "./PlayerDocumentsTab.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__